<!-- A failure where it was awaited (proposals 2026-09-30): the preview's or the videos' own layout,
     not a blank page. The card lists the stages with the one that failed and why; the buttons
     follow whose failure it is. -->
<div class="order-layout step-error__layout" *ngIf="job && job.error as error">
  <section class="order-main">
    <h1 class="flow-title" *ngFor="let line of [title]">{{ line.text }}<span *ngIf="line.name" class="rf-name-with"><span class="rf-name" [title]="line.name">{{ line.name }}</span>{{ line.mark }}</span>{{ line.after }}</h1>
    <p class="flow-subtitle" *ngFor="let line of [subtitle]">{{ line.text }}<span *ngIf="line.name" class="rf-name-with"><span class="rf-name" [title]="line.name">{{ line.name }}</span>{{ line.mark }}</span>{{ line.after }}</p>

    <div class="order-devices">
      <!-- The preview never rendered: the empty studio says so. The videos keep the frames already seen. -->
      <app-render-still-devices *ngIf="!isVideos || !job.preview; else frames" pending="failed" [name]="job.name"></app-render-still-devices>
      <ng-template #frames>
        <app-render-still-devices [landscape]="job.preview?.landscape || ''" [portrait]="job.preview?.portrait || ''" [name]="job.name" [stopped]="stoppedLabel" [veiled]="veil"></app-render-still-devices>
      </ng-template>
    </div>
  </section>

  <aside class="order-card order-card--progress order-card--failed">
    <h2>{{ isVideos ? 'Both videos' : 'What stopped the preview' }}</h2>
    <ol class="preview-stages">
      <li class="preview-stages__item is-done">
        <ng-container *ngTemplateOutlet="doneMark"></ng-container>
        <span class="preview-stages__label">{{ isVideos ? paidLabel : 'Uploaded' }}</span>
        <small *ngIf="!isVideos">{{ uploadedDetail }}</small>
      </li>
      <ng-container *ngIf="!isVideos; else videoStage">
        <ng-container *ngFor="let stage of stages; let i = index">
          <li class="preview-stages__item" [class.is-done]="stageFate(i) === 'done'" [class.is-failed]="stageFate(i) === 'failed'">
            <ng-container *ngIf="stageFate(i) === 'done'"><ng-container *ngTemplateOutlet="doneMark"></ng-container></ng-container>
            <ng-container *ngIf="stageFate(i) === 'failed'"><ng-container *ngTemplateOutlet="failMark"></ng-container></ng-container>
            <span *ngIf="stageFate(i) === 'pending'" class="preview-stages__mark" aria-hidden="true"></span>
            <span class="preview-stages__label">{{ stageFate(i) === 'done' ? stage.doneLabel : stage.label }}</span>
          </li>
          <li *ngIf="stageFate(i) === 'failed'" class="preview-stages__reason">{{ error.text }} <button *ngIf="error.about === 'textures'" class="preview-stages__guide" type="button" (click)="openGuide()">How to pack textures into the FBX</button></li>
        </ng-container>
      </ng-container>
      <ng-template #videoStage>
        <li class="preview-stages__item is-failed">
          <ng-container *ngTemplateOutlet="failMark"></ng-container>
          <span class="preview-stages__label">Rendering the videos</span>
          <small *ngIf="error.progress">{{ error.progress }}%</small>
        </li>
        <li class="preview-stages__reason">{{ error.text }}</li>
      </ng-template>
    </ol>

    <div class="order-card__progress failed-actions">
      <div *ngIf="isMock" class="rf-notice failed-actions__note">Simulated failure. Nothing was uploaded or charged.</div>
      <!-- No render starts from here: a failed preview goes back to the upload, paid videos to support. -->
      <a *ngIf="isVideos; else uploadAgain" class="rf-button order-card__cta" [href]="supportHref">Contact support</a>
      <ng-template #uploadAgain><button class="rf-button order-card__cta" type="button" (click)="onAnotherModel()">{{ primaryLabel }}</button></ng-template>
      <!-- While a removal is being confirmed, the confirmation takes the place of these two (the
           step still fits 1366 × 650). -->
      <ng-container *ngIf="!confirmingRemove">
        <a *ngIf="!isVideos; else backToLibrary" class="rf-text-link order-card__cancel" [href]="supportHref">Contact support</a>
        <!-- Paid videos that stopped stay in the library for support: the way back there, in the place
             the failed preview's second link takes (designer, 2026-11-02: no way back on a phone). -->
        <ng-template #backToLibrary><a class="rf-text-link order-card__cancel" routerLink="/render/library">Back to your library</a></ng-template>
        <p class="order-card__fine">{{ fine }}</p>
      </ng-container>
      <!-- Removing a failed preview: one link, then a second click on a button that says what goes. -->
      <ng-container *ngIf="canRemove">
        <button *ngIf="!confirmingRemove; else removeConfirm" class="rf-text-link failed-remove" type="button" (click)="confirmingRemove = true">Remove from library</button>
        <ng-template #removeConfirm>
          <div class="rf-notice rf-notice--error failed-remove__confirm" role="group" aria-label="Remove this model">
            <p>Remove <strong class="rf-name" [title]="job.name">{{ job.name }}</strong> and its files? This can’t be undone.</p>
            <div class="failed-remove__actions">
              <button class="failed-remove__yes" type="button" (click)="onRemove()">Remove</button>
              <button class="rf-text-link" type="button" (click)="confirmingRemove = false">Keep it</button>
            </div>
          </div>
        </ng-template>
      </ng-container>
    </div>
  </aside>
</div>

<ng-template #doneMark>
  <span class="preview-stages__mark" aria-hidden="true"><svg width="12" height="12" viewBox="0 0 16 16" fill="none"><path d="M1 8.94753L5.2 13.1475L15 3.34753" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
</ng-template>

<ng-template #failMark>
  <span class="preview-stages__mark" aria-hidden="true"><svg width="10" height="10" viewBox="0 0 12 12" fill="none"><path d="M2 2l8 8M10 2l-8 8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></span>
</ng-template>
